let userAccessToken: string | null = null;
let adminAccessToken: string | null = null;

export const tokenStore = {
  getUserToken: () => userAccessToken,
  setUserToken: (token: string | null) => {
    userAccessToken = token;
  },
  getAdminToken: () => adminAccessToken,
  setAdminToken: (token: string | null) => {
    adminAccessToken = token;
  },
  clearAll: () => {
    userAccessToken = null;
    adminAccessToken = null;
  }
};
